module.exports = __webpack_public_path__ + "static/Submarkets_2021_Release_7-0f240afe9e209023777ab9c05baaa742.png";